import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from '@common/services/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { LastUpdateService } from './last-update.service';
import { StateService } from './state.service';

@Injectable({
    providedIn: 'root'
})
export class BaseKendoListService {
    private activatedRoute: ActivatedRoute;

    constructor(
        activatedRoute: ActivatedRoute,
        private dialogService: ModalService,
        private translateService: TranslateService,
        private stateService: StateService,
        private router: Router,
        private lastUpdateService: LastUpdateService
    ) {
        this.activatedRoute = activatedRoute;
    }

    getDialogService(): ModalService {
        return this.dialogService;
    }

    getTranslateService(): TranslateService {
        return this.translateService;
    }

    getStateService(): StateService {
        return this.stateService;
    }

    getRouter(): Router {
        return this.router;
    }

    getLastUpdateService(): LastUpdateService {
        return this.lastUpdateService;
    }

    getActivatedRoute(): ActivatedRoute {
        return this.activatedRoute;
    }
}
